export const torchJsonSelector = ({torchJson}) => torchJson